import { METADATA, MODULE_TYPE, PARAMETERS } from './common';

/* =========== ENUM ============ */
export enum PURCHASED_PACKAGE_FROM {
  JOB = 'payForJob',
  CREDIT = 'payForCredit',
}

export enum WALLET_TRANSACTION_CODE {
  SERVICE_CHARGE = 'SC', // user pay for sr
  JOB_REFUND = 'JR', // refund job
  SERVICE_FEE = 'SF', // sitter receive credit for job done
  PAYMENT_RECEIVED = 'PR', // user top up credit
  PAYMENT_MADE = 'PM', // withdraw money
  CREDIT = 'CR', // admin credit
  DEBIT = 'DR', // admin debit
  PAYMENT_PROCESSING_FEE = 'PPF', // payment processing fee
}

/* =========== INTERFACE ============ */
export interface PARENT_SUBSCRIPTION_DATA {
  profile_picture: string | null;
  User: {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    phone_number: string;
  };
}
export interface CURRENT_BALANCE_CREDIT_RESPONSE {
  balance: number;
  sitter_rate: number;
  id: string;
  parent_id: string;
  number: string;
  is_trial: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  parent: PARENT_SUBSCRIPTION_DATA;
  expiredAt: string;
}

export interface TRANSACTION_CREDIT_ITEM_TYPE {}

export interface GET_PACKAGE_PARAMS extends PARAMETERS {
  sort?: string;
}

export interface AVAILABLE_PACKAGE_RESPONSE {
  metadata: METADATA;
  data: AVAILABLE_PACKAGE_ITEM_TYPE[];
}

export interface AVAILABLE_PACKAGE_ITEM_TYPE {
  id: string;
  name: string;
  description: string;
  parent_rate: number;
  sitter_rate: number;
  price: number;
  is_active: boolean;
  is_read_only: boolean;
  tag: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  is_can_purchase: boolean;
}

export interface GET_SUBSCRIPTION_PURCHASED_PARAMS extends PARAMETERS {
  has_balance: boolean;
  parent_id: string;
}

export interface SUBSCRIPTION_PURCHASED_RESPONSE {
  metadata: METADATA;
  records: SUBSCRIPTION_PURCHASED_ITEM[];
}

export interface SUBSCRIPTION_PURCHASED_ITEM
  extends CURRENT_BALANCE_CREDIT_RESPONSE {
  package: {
    parent_rate: number;
    sitter_rate: number;
    price: number;
    id: string;
    name: string;
  };
}

export interface GET_TRANSACTION_HISTORY_PARAMS extends PARAMETERS {
  offset: number;
  module_type?: MODULE_TYPE;
  code?: string;
}

export interface TRANSACTION_HISTORY_BY_CREDIT_RESPONSE {
  metadata: METADATA;
  data: TRANSACTION_HISTORY_BY_CREDIT_ITEM[];
}

export interface TRANSACTION_HISTORY_BY_CREDIT_ITEM {
  id: string;
  type: string;
  timestamp: string;
  number: string;
  user_id: string;
  sr_id: any;
  booking_id: any;
  job_id: string;
  payment_method_type: string;
  doc_ref_no: string;
  last4: any;
  cash_txn_id: any;
  amount: string;
  tax_amount: string;
  total_amount: string;
  remark: any;
  createdBy: any;
  updatedBy: any;
  deletedBy: any;
  include_in_payout: boolean;
  module_type: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  TransactionType: {
    code: string;
    title: string;
    sign: '+' | '-';
  };
  Job: {
    salary_per_hour: number;
    total: number;
    total_origin: number;
    total_extension: number;
    total_hours: number;
    total_hours_origin: number;
    total_hours_extension: number;
    sitter_earning: number;
    sitter_rate: number;
    id: string;
    number: string;
    parent_id: string;
    sitter_id: string;
    sr_id: string;
    children: {
      id: string;
      picture: any;
      age_range: number;
      full_name: string;
      date_of_birth: string;
    }[];
    start_datetime: string;
    end_datetime: string;
    end_datetime_origin: string;
    address: {
      id: string;
      name: string;
      Region: {
        name: string;
      };
      street: string;
      region_id: string;
      postal_code: string;
      unit_number: string;
      block_number: string;
      building_name: string;
    };
    special_notes: {
      '0': string;
      '1': string;
      '2': string;
    };
    type: string;
    status: string;
    is_ac_job: boolean;
    is_trial_job: boolean;
    is_paid: boolean;
    is_extend_ac_job: boolean;
    createdAt: string;
    updatedAt: string;
    deletedAt: any;
  };
  CashTransaction: any;
}

export interface GET_TRANSACTION_HISTORY_BY_CASH_PARAMS extends PARAMETERS {
  offset?: number;
}

export interface TRANSACTION_HISTORY_BY_CASH_RESPONSE {
  metadata: METADATA;
  data: TRANSACTION_HISTORY_BY_CASH_ITEM[];
}

export interface GET_TRANSACTION_HISTORY_BY_CASH_PARAMS extends PARAMETERS {
  offset?: number;
}

export interface TRANSACTION_HISTORY_BY_CASH_ITEM {
  id: string;
  number: string;
  amount: number;
  tax_amount: number;
  total_amount: number;
  status: string;
  payment_method_type: string;
  timestamp: string;
  remark: string;
  created_at: string;
  transaction_type: {
    code: string;
    title: string;
  };
  job: {
    id: string;
    total: number;
    number: string;
    start_datetime: string;
    end_datetime: string;
    total_hours: number;
  };
  ac_base_request: {
    id: string;
    number: string;
    status: string;
  };
}
